"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useProductOfferingLoading = exports.useProductOfferingError = exports.useProductOffering = void 0;

var _react = require("react");

var _reactRedux = require("react-redux");

var _productOffering = require("../reducers/productOffering");

var useProductOffering = function useProductOffering(prospectId, baseUrl, authToken) {
  var dispatch = (0, _reactRedux.useDispatch)();
  var productOffering = (0, _reactRedux.useSelector)((0, _productOffering.getProductOffering)(prospectId));
  (0, _react.useEffect)(function () {
    if (baseUrl && authToken) {
      dispatch((0, _productOffering.fetchProductOfferingIfNeeded)(prospectId, baseUrl, authToken));
    }
  }, [prospectId, baseUrl, authToken]);
  return productOffering;
};

exports.useProductOffering = useProductOffering;

var useProductOfferingLoading = function useProductOfferingLoading() {
  var productOfferingLoading = (0, _reactRedux.useSelector)(_productOffering.getProductOfferingLoading);
  return productOfferingLoading;
};

exports.useProductOfferingLoading = useProductOfferingLoading;

var useProductOfferingError = function useProductOfferingError() {
  var productOfferingError = (0, _reactRedux.useSelector)(_productOffering.getProductOfferingError);
  return productOfferingError;
};

exports.useProductOfferingError = useProductOfferingError;